// Client Environment Configuration
// This file is accessible to Cursor Chat for development assistance

import { ClientConfig } from './types';

const config: Record<string, ClientConfig> = {
  development: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    SERVER_URL: process.env.REACT_APP_SERVER_URL || 'http://localhost:5000',
    ENVIRONMENT: 'development',
    VERSION: '1.0.0',
    
    // Feature flags
    ENABLE_DEBUG: true,
    ENABLE_ANALYTICS: false,
    ENABLE_MOCK_DATA: false,
    SHOW_DEV_TOOLS: true,
    LOG_LEVEL: 'debug',
    
    // External services (development keys)
    GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    // FIREBASE_CONFIG: {
    //   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    //   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    //   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // }
  },
  
  production: {
    API_URL: process.env.REACT_APP_API_URL || '/api',
    SERVER_URL: process.env.REACT_APP_SERVER_URL || '',
    ENVIRONMENT: 'production',
    VERSION: process.env.REACT_APP_VERSION || '1.0.0',
    
    // Feature flags
    ENABLE_DEBUG: false,
    ENABLE_ANALYTICS: true,
    ENABLE_MOCK_DATA: false,
    SHOW_DEV_TOOLS: false,
    LOG_LEVEL: 'error',
    
    // External services (production keys from env vars)
    GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    // FIREBASE_CONFIG: {
    //   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    //   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    //   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // }
  }
};

const currentEnv = process.env.NODE_ENV || 'development';
export default config[currentEnv];

// Usage in your React components:
// import config from './config.env';
// console.log('API URL:', config.API_URL);
